import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

const ARIA_LABEL_TRUNK = 'Trunk';

interface TrunkProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function Trunk(props: TrunkProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label={ARIA_LABEL_TRUNK}
      width={193}
      height={358}
      viewBox="0 0 193 358"
      position={{top: 72, right: 10}}
    >
      <path
        d="M40 203C40 282 7.0005 350 2 357C42 357 114.751 356.308 146 343C149.112 341.568 151.861 339.711 154 338C161.202 332.238 172.997 322.162 179 306C192 270.999 192 213.055 192 179.049V179V178.951C192 144.945 192 87.001 179 52C172.997 35.838 161.202 25.7621 154 20C151.861 18.2891 149.112 16.4319 146 15C114.751 1.69218 42 1 2 1C7.0005 8 40 76 40 155V179V203Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <ellipse
        cx="183.91"
        cy="179"
        rx="5"
        ry="10"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></ellipse>
      <path
        d="M165.422 30.5C164.864 28.0445 152.644 19 146 15C155.404 29 165.422 59 169 72C169 66.5 166.444 35 165.422 30.5Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M165.422 327.5C164.864 329.955 152.644 339 146 343C155.404 329 165.422 299 169 286C169 291.5 166.444 323 165.422 327.5Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M40 203C40 282 7.0005 350 2 357C42 357 114.751 356.308 146 343C149.112 341.568 151.861 339.711 154 338C161.202 332.238 172.997 322.162 179 306C192 270.999 192 213.055 192 179.049V179V178.951C192 144.945 192 87.001 179 52C172.997 35.838 161.202 25.7621 154 20C151.861 18.2891 149.112 16.4319 146 15C114.751 1.69218 42 1 2 1C7.0005 8 40 76 40 155V179V203Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M169 76C168 60 167 44 165 30"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M146 343C158.285 320.208 176 280.12 176 218.772C176 213.172 176 183 176 179C176 175 176 144.828 176 139.228C176 77.8799 158.285 37.7921 146 15"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M169 282C168 298 167 314 165 328"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <ellipse
        cx="183.91"
        cy="179"
        rx="5"
        ry="10"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M40 179L176 179"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
